import { jsx as _jsx } from "react/jsx-runtime";
import { Collapsible, Text } from '@chakra-ui/react';
import { fieldErrorColor, sansFontFamily } from '@client/theme';
export const CheckoutFieldError = (props) => (_jsx(Collapsible.Root, { open: Boolean(props.errorText), children: _jsx(Collapsible.Content, { children: _jsx(Text, { fontFamily: sansFontFamily, fontSize: 14, color: fieldErrorColor, lineHeight: 1, paddingTop: 2.5, children: props.errorText }) }) }));
